// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"LoginButton_wrapperComponent__ipSdl","authButton":"LoginButton_authButton__LKE76","logged":"LoginButton_logged__iC3Z5","paper":"LoginButton_paper__3Q-u4"};